<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="RKTK"></IndexBase>
    <form id="mainFrom" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] RKTK {{ typeName }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>
                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('doc_date')" fieldName="Doc_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Doc_Date" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Doc_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <div class="field grid">
                                <label for="No_Wo" class="col-4">{{ $t('no_wo') }}</label>
                                <div class="col-6 md-6">
                                    <InputText name="Code" v-model="header.No_WO" type="text" :placeholder="$t('no_wo')"
                                        v-if="header"
                                        :disabled="true"/>
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                    :placeholder="$t('job_desc')" v-if="header" @change="onChange()"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Doc_Date != null ? this.header.Doc_Date  : null)}" 
                                    :disabled="true"
                                    />
                            </FormField>
                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                    :placeholder="$t('no_spk')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('budget')" fieldName="Budget" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Budget" v-model="header.Budget" required="true"
                                    :placeholder="$t('budget')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('Current_MC')" fieldName="Current_MC" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Current_MC" v-model="header.Current_MC" required="true"  :useGrouping="true" 
                                    :placeholder="$t('Current_MC')" v-if="header"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                            <FormField :labelName="$t('Previous_MC')" fieldName="Previous_MC" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Previous_MC" v-model="header.Previous_MC" required="true" type="text"
                                    :placeholder="$t('Previous_MC')" v-if="header"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                        </div>
                        <div class="col-6">
                            <FormField :labelName="$t('Contract_Amount')" fieldName="Contract_Amount" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Contract_Amount" v-model="header.Contract_Amount" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('Contract_Amount')" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Contract_Amount }"/>
                            </FormField>
                            <FormField :labelName="$t('Calculate ' + labelPrevious)" fieldName="Total_Initial_Contract" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Initial_Contract" v-model="header.Total_Initial_Contract" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('Calculate ' + labelPrevious)" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Total_Initial_Contract }"/>
                            </FormField>
                            <FormField :labelName="$t('Calculate ' + labelCurrent)" fieldName="Total_Actual_Contract" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Actual_Contract" v-model="header.Total_Actual_Contract" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('Calculate ' + labelCurrent)" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Total_Actual_Contract }"/>
                            </FormField>
                            <FormField :labelName="$t('Rounding')" fieldName="Rounding" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Rounding" v-model="header.Rounding" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('Rounding')" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Rounding }"/>
                            </FormField>
                            <FormField :labelName="$t('Deviasi')" fieldName="Deviasi" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Deviasi" v-model="header.Deviasi" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('Deviasi')" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Deviasi }"/>
                            </FormField>
                            <FormField :labelName="$t('Deviasi_Percent')" fieldName="Deviasi_Percent" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Deviasi_Percent" v-model="header.Deviasi_Percent" required="true" :useGrouping="true" :maxFractionDigits="3" :minFractionDigits="0"
                                    :placeholder="$t('Deviasi_Percent')" v-if="header" 
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Deviasi_Percent }"/>
                            </FormField>
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_Appr1" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_Appr1" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr1" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr1 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_Appr2" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_Appr2" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr2" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr2 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_Appr3" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_Appr3" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr3" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion:header.Appr_As3, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, contractorcode : header.Contractor_Code,companycode: header.Company_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr3 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL  || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>
                            </div>
                        
                        <div class="col-12">
                            <h5 class="mb-2">Main Scope</h5>
                            <div style="max-height: 400px; overflow: auto;">
                                <DataTable v-if="header && header.ScopeMain" 
                                    :value="header.ScopeMain"
                                    class="p-datatable-sm editable-cells-table"
                                    editMode="cell"
                                    :rowClass="hideRow"
                                    showGridlines
                                    >
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" style="width: 85px; max-width: 85px; min-width: 85px;"/>
                                    <Column :header="$t('no')" :rowspan="2" style="width: 65px; max-width: 65px; min-width: 65px;"/>
                                    <Column :header="$t('scope')" :rowspan="2" style="width: 350px; max-width: 350px; min-width: 350px;"/>
                                    <Column :header="$t('unit')" :rowspan="2" style="width: 65px; max-width: 65px; min-width: 65px;" />
                                    <Column :header="$t('volume')" :colspan="3" style="width: 300px; max-width: 300px; min-width: 300px;" />
                                    <Column :header="$t('unit_price')" :colspan="2" style="width: 200px; max-width: 200px; min-width: 200px;" />
                                    <Column :header="$t('amount')" :colspan="3" style="width: 360px; max-width: 360px; min-width: 360px;" />
                                </Row>
                                <Row>
                                    <Column :header="$t(labelPrevious)" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t(labelCurrent)" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Deviasi')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Material')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Labour')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t(labelPrevious)" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                    <Column :header="$t(labelCurrent)" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                    <Column :header="$t('Deviasi')" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type" style="width: 85px; max-width: 85px; min-width: 85px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Section_Type"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_BoQ" style="width: 65px; max-width: 65px; min-width: 65px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope" style="width: 350px; max-width: 350px; min-width: 350px;">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit" style="width: 65px; max-width: 65px; min-width: 65px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Previous" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Previous"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Current" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Current"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Deviasi" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Deviasi"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Material_Price" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Material_Price"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Labour_Price" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Labour_Price"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Previous" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Previous"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Current" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Current"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Deviasi" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Deviasi"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                            </div>
                        </div>
                        <div class="col-12">
                            <h5 class="mb-2">Additional Scope</h5>
                            <div style="max-height: 400px; overflow: auto;">
                                <DataTable v-if="header && !header.Is_Additional" 
                                    :value="header.ScopeAdditional"
                                    class="p-datatable-sm editable-cells-table"
                                    editMode="cell"
                                    :rowClass="hideRow"
                                    showGridlines
                                    >
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" style="width: 85px; max-width: 85px; min-width: 85px;"/>
                                    <Column :header="$t('no')" :rowspan="2" style="width: 65px; max-width: 65px; min-width: 65px;"/>
                                    <Column :header="$t('scope')" :rowspan="2" style="width: 350px; max-width: 350px; min-width: 350px;"/>
                                    <Column :header="$t('unit')" :rowspan="2" style="width: 65px; max-width: 65px; min-width: 65px;" />
                                    <Column :header="$t('volume')" :colspan="3" style="width: 300px; max-width: 300px; min-width: 300px;" />
                                    <Column :header="$t('unit_price')" :colspan="2" style="width: 200px; max-width: 200px; min-width: 200px;" />
                                    <Column :header="$t('amount')" :colspan="3" style="width: 360px; max-width: 360px; min-width: 360px;" />
                                </Row>
                                <Row>
                                    <Column :header="$t(labelPreviousAdditional)" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t(labelCurrent)" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Deviasi')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Material')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t('Labour')" style="width: 100px; max-width: 100px; min-width: 100px;" />
                                    <Column :header="$t(labelPreviousAdditional)" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                    <Column :header="$t(labelCurrent)" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                    <Column :header="$t('Deviasi')" style="width: 120px; max-width: 120px; min-width: 120px;" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type" style="width: 85px; max-width: 85px; min-width: 85px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Section_Type"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_BoQ" style="width: 65px; max-width: 65px; min-width: 65px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope" style="width: 350px; max-width: 350px; min-width: 350px;">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit" style="width: 65px; max-width: 65px; min-width: 65px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Previous" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Previous"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Current" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Current"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Volume_Deviasi" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Volume_Deviasi"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Material_Price" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Material_Price"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Labour_Price" style="width: 100px; max-width: 100px; min-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Labour_Price"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Previous" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Previous"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Current" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Current"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Amount_Deviasi" style="width: 120px; max-width: 120px; min-width: 120px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Amount_Deviasi"
                                        :disabled="true"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                            </div>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>
<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data(){
        return {
            indexName: "AddendumMCIndex",
            url: this.$API_URL + "AddendumMC/GetDataRKTK/",
            header: null,
            mode: "",
            type: "",
            typeName: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            dataChangesLog:this.$dataChangesLog3,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelPrevious : "",
            labelPreviousAdditional : "Previous Initial Contract",
            labelCurrent : "",
            submitted2 : false,
            detailLog : null,
            submitted: false,
            onlyDraft: false,
        }
    },
    methods:{
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode + "/" + this.type)
                .then((response) => {

                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    console.log(self.header);
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    self.labelPrevious = "Previous " + self.header.name_Volume_Previous;
                    self.labelCurrent = "Current " + self.header.name_Volume_Current;
                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                        });
                    }
                    
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        confirm(event){
            this.submitted = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE)
            {
                if(!this.header.Doc_Date){
                    return;
                }
            }
            if(((self.header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL  || self.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) &&  !this.header.Reason)
                || (this.labelAppr1 && !this.header.Username_Appr1) || (this.labelAppr2 && !this.header.Username_Appr2) || (this.labelAppr3 && !this.header.Username_Appr3))
            {
                return false;
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        confirmDraft(event)
        {
            this.submitted = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE)
            {
                if(!this.header.Doc_Date){
                    return;
                }
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        saveData(){
            this.$emit('block-ui');
            var self = this;
            // var Actual_Contract_Amount = 0;
            // Actual_Contract_Amount = this.header.Total_Initial_Contract - this.header.Deviasi;
            // if(Actual_Contract_Amount < 0){
            //     self.showError("Error", "Cannot Submit, Total Actual Contract cannot be Minus, Please check again.");
            //     return;
            // }
            if(this.header)
            {
                this.header.Type = this.type;
                this.header.Main_Data_Id = this.mainid;
                this.header.Doc_Date_String = moment(this.header.Doc_Date).format("YYYY/MM/DD").toString();
            }
            this.$axios.post(this.$API_URL + "AddendumMC/SaveRKTK/", this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) 
                        {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: `RKTK ${this.typeName} has been deleted successfully`, life: 3000 }, query: { activeIndex: 1 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: `RKTK ${this.typeName} has been saved successfully`, life: 3000 }, query: { activeIndex: 1 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/AddendumMC/Index", query: { activeIndex: 1 } });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        hideRow(data) {
            if (data.mode == this.$FORM_MODE_DELETE) {
                return 'row-hidden';
            }
            
            if (this.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || 
                this.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION) {
                if (data.status == this.$FORM_MODE_CREATE) {
                    return 'row-created';
                } else if (data.status == this.$FORM_MODE_EDIT) {
                    return 'row-edited';
                } else if (data.status == this.$FORM_MODE_DELETE) {
                    return 'row-deleted';
                }
            }
            
            return null;
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.type = this.$route.query.type;
        if(this.type == this.$TypeMC.MC0)
            this.typeName = this.$TypeNameMC.MC0;
        else if(this.type == this.$TypeMC.MC_BETWEEN)
            this.typeName = this.$TypeNameMC.MC_BETWEEN;
        else if(this.type == this.$TypeMC.MC100)
            this.typeName = this.$TypeNameMC.MC100;
        else
            this.typeName = "";
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>

<style scoped>
/* Table base styling */
::v-deep(.editable-cells-table) {
   font-size: 1rem;
}

::v-deep(.editable-cells-table .p-inputtext),
::v-deep(.editable-cells-table .p-inputnumber-input),
::v-deep(.editable-cells-table .p-inputtextarea) {
   font-size: 1rem;
   width: 100%;
}

::v-deep(.p-datatable .p-datatable-tbody > tr > td) {
   white-space: normal;
   word-wrap: break-word;
}

/* Textarea height */
::v-deep(.p-datatable .p-datatable-tbody > tr > td textarea) {
   min-height: 60px;
}

/* Row coloring based on mode status */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td) {
   background-color: #c8e6c9 !important; /* Light green */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover > td) {
   background-color: #a5d6a7 !important; /* Darker green on hover */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td) {
   background-color: #fff9c4 !important; /* Light yellow */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover > td) {
   background-color: #fff59d !important; /* Darker yellow on hover */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td) {
   background-color: #ffcdd2 !important; /* Light red */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover > td) {
   background-color: #ef9a9a !important; /* Darker red on hover */
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-hidden) {
   display: none;
}

/* Row tooltip on hover */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted) {
   position: relative;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td:first-child::before),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td:first-child::before),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td:first-child::before) {
   position: absolute;
   left: 50%;
   top: -35px;
   transform: translateX(-50%);
   padding: 6px 12px;
   border-radius: 4px;
   font-size: 12px;
   font-weight: 600;
   white-space: nowrap;
   opacity: 0;
   visibility: hidden;
   transition: opacity 0.2s ease, visibility 0.2s ease;
   z-index: 1000;
   pointer-events: none;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover > td:first-child::before),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover > td:first-child::before),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover > td:first-child::before) {
   opacity: 1;
   visibility: visible;
}

/* Tooltip content and colors */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td:first-child::before) {
   content: "Add New";
   background-color: #2e7d32;
   color: #ffffff;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td:first-child::before) {
   content: "Edit";
   background-color: #f9a825;
   color: #000000;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td:first-child::before) {
   content: "Delete";
   background-color: #c62828;
   color: #ffffff;
}

/* Tooltip arrow */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td:first-child::after),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td:first-child::after),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td:first-child::after) {
   content: "";
   position: absolute;
   left: 50%;
   top: -8px;
   transform: translateX(-50%);
   border-width: 6px;
   border-style: solid;
   opacity: 0;
   visibility: hidden;
   transition: opacity 0.2s ease, visibility 0.2s ease;
   z-index: 1000;
   pointer-events: none;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover > td:first-child::after),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover > td:first-child::after),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover > td:first-child::after) {
   opacity: 1;
   visibility: visible;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td:first-child::after) {
   border-color: #2e7d32 transparent transparent transparent;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td:first-child::after) {
   border-color: #f9a825 transparent transparent transparent;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td:first-child::after) {
   border-color: #c62828 transparent transparent transparent;
}

/* Center header content */
::v-deep(.p-datatable .p-datatable-thead > tr > th) {
   text-align: center;
}

::v-deep(.p-datatable .p-datatable-thead > tr > th .p-column-header-content) {
   justify-content: center;
}

/* Yellow background for mismatched fields */
::v-deep(.bg-yellow) {
   background-color: #fcf1b1 !important;
}
</style>